<template>
  <div class="card h-100 shadow-sm border-0 kpi-card" :class="cardClass">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-3">
        <span class="kpi-icon-box" :class="iconBoxClass">
          <i :class="icon"></i>
        </span>
        <div class="text-right">
          <span class="badge px-2 py-1" :class="rateBadgeClass">
            {{ rateText }}
          </span>
          <div class="small text-muted mt-1">Total: <strong>{{ total }}</strong></div>
        </div>
      </div>

      <h5 class="text-muted text-uppercase font-weight-bold letter-spacing-1 small mb-1">
        {{ title }}
      </h5>
      <div class="d-flex align-items-baseline mb-3">
        <h2 class="display-4 font-weight-bold text-dark mb-0 mr-2">
          {{ mainValue }}
        </h2>
        <span class="small font-weight-bold" :class="trendClass">
          <i class="bi bi-arrow-up-right"></i> {{ trendPercent }}%
        </span>
      </div>

      <!-- Desglose de 2 columnas -->
      <div class="row no-gutters py-2 mb-3 bg-light rounded text-center">
        <div class="col-6 border-right">
          <div class="small text-muted font-weight-bold">{{ stat1Label }}</div>
          <div class="h5 mb-0 font-weight-bold" :class="stat1Class">
            <i class="mr-1" :class="stat1Icon"></i>{{ stat1Value }}
          </div>
        </div>
        <div class="col-6">
          <div class="small text-muted font-weight-bold">{{ stat2Label }}</div>
          <div class="h5 mb-0 font-weight-bold" :class="stat2Class">
            <i class="mr-1" :class="stat2Icon"></i>{{ stat2Value }}
          </div>
        </div>
      </div>

      <!-- Barra de Progreso Visual -->
      <div class="mb-1 d-flex justify-content-between small text-muted">
        <span>{{ bar1Label }}: <strong :class="bar1Class">{{ bar1Percent }}%</strong></span>
        <span>{{ bar2Label }}: <strong :class="bar2Class">{{ bar2Percent }}%</strong></span>
      </div>
      <div class="progress" style="height: 8px;">
        <div
          class="progress-bar"
          :class="bar1BarClass"
          role="progressbar"
          :style="{ width: bar1Percent + '%' }"
          :aria-valuenow="bar1Percent"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
        <div
          class="progress-bar"
          :class="bar2BarClass"
          role="progressbar"
          :style="{ width: bar2Percent + '%' }"
          :aria-valuenow="bar2Percent"
          aria-valuemin="0"
          aria-valuemax="100"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KpiCard",
  props: {
    cardClass: { type: String, default: "" },
    icon: { type: String, required: true },
    iconBoxClass: { type: String, default: "" },
    rateBadgeClass: { type: String, default: "" },
    rateText: { type: [String, Number], default: "" },
    total: { type: [String, Number], default: "" },
    title: { type: String, required: true },
    mainValue: { type: [String, Number], default: 0 },
    trendPercent: { type: [String, Number], default: 0 },
    trendClass: { type: String, default: "text-success" },
    stat1Label: { type: String, default: "Enviados" },
    stat1Value: { type: [String, Number], default: 0 },
    stat1Icon: { type: String, default: "bi bi-check-circle" },
    stat1Class: { type: String, default: "text-success" },
    stat2Label: { type: String, default: "No Enviados" },
    stat2Value: { type: [String, Number], default: 0 },
    stat2Icon: { type: String, default: "bi bi-x-circle" },
    stat2Class: { type: String, default: "text-danger" },
    bar1Label: { type: String, default: "Tasa de Entrega" },
    bar1Percent: { type: [String, Number], default: 0 },
    bar1Class: { type: String, default: "text-success" },
    bar1BarClass: { type: String, default: "bg-success" },
    bar2Label: { type: String, default: "Fallo" },
    bar2Percent: { type: [String, Number], default: 0 },
    bar2Class: { type: String, default: "text-danger" },
    bar2BarClass: { type: String, default: "bg-danger" },
  },
};
</script>
